module.exports = __webpack_public_path__ + "img/icon_contact_11.6259a8b.svg";